import { useDocumentTitle } from "@/common/useDocumentTitle";
import FeaturedUsers from "./FeaturedUsers";
import LandingFooter from "./LandingFooter";
import LandingHero from "./LandingHero";
import LandingSignUp from "./LandingSignUp";
import ValueStrip from "./ValueStrip";

/**
 * What "/" shows a visitor with no account.
 *
 * The frame around it is nearly bare on purpose — `useAppChrome` drops both
 * sidebars and the header's interval here, leaving the brand, the theme switch
 * and the way to the sign-up. Every panel this page does not have is an answer
 * to "when is this?", and someone who has not seen a timeline yet has not asked.
 *
 * Owns its own scrolling: `App` hands the outlet a `min-h-0` flex slot inside an
 * `overflow-hidden` shell, so a page taller than the viewport must scroll
 * itself or be clipped.
 */
export default function Landing() {
  useDocumentTitle("Eventera — explore history, write your own");

  return (
    <div className="h-full w-full overflow-y-auto">
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-14 px-6 py-12 sm:px-8 sm:py-16">
        <LandingHero />
        <ValueStrip />
        <FeaturedUsers />
        {/* Popular collections would go here, and cannot yet: `is_public` is
            only ever consulted for a collection someone has already named, so
            there is no endpoint that lists public collections to choose from.
            That section is backend work first. */}
        <LandingSignUp />
        <LandingFooter />
      </div>
    </div>
  );
}
